import { jsxs as B, Fragment as Re, jsx as a } from "react/jsx-runtime";
import { useState as q, useMemo as v, useCallback as F, useRef as ce, useEffect as z } from "react";
import { ReloadOutlined as je, ArrowLeftOutlined as ke, SearchOutlined as Ze, FileTextOutlined as Ke, SafetyCertificateOutlined as Ee, MedicineBoxOutlined as xe, WalletOutlined as et, ExperimentOutlined as tt, TeamOutlined as nt, ReconciliationOutlined as rt, ContainerOutlined as at, PrinterOutlined as st, CalendarOutlined as ot, PaperClipOutlined as it, GiftOutlined as ct, DollarOutlined as lt, UnorderedListOutlined as dt, InboxOutlined as ut, CustomerServiceOutlined as mt, PhoneOutlined as ft, MessageOutlined as ht, ScheduleOutlined as gt, CloseOutlined as yt } from "@ant-design/icons";
import { Flex as D, Input as Qe, Button as re, Typography as ne, Spin as ge, Card as bt, Tabs as Ye, Alert as $e, Menu as pt } from "antd";
import { b as vt, u as ye, c as te, E as Me, d as _t, a as Ve } from "./use-definition-0yWcQDPI.js";
import { u as Ue, L as We, a as St } from "./TabListView-DTlHiJjA.js";
import { s as he, g as He, e as Tt, f as qe, D as wt, t as ze, a as Ge, i as $t } from "./DataGrid-Cy1qOpyR.js";
import { Q as Le, S as Lt, F as Ae, b as Ie, u as Pt, L as Ft } from "./FormView-CWSNCHG6.js";
import { q as Nt, i as Ot, m as kt, u as Et, z as xt } from "./fetcher-CUYp7JR1.js";
import "idb";
import { g as At, a as It, k as Be, h as H, j as Se } from "./templateResolver-BchYA4i9.js";
import { useNavigate as Pe, useLocation as Bt, Link as Dt, Outlet as Xe, useParams as Ct } from "@tanstack/react-router";
import { useInfiniteQuery as Rt, useQueryClient as jt } from "@tanstack/react-query";
function Je(e) {
  const t = e ? `/query/${e}/list?meta=true` : null, [{ data: n, error: l, isLoading: s, isFetching: d }] = vt(t, {
    staleTime: 1 / 0,
    retry: 3,
    retryDelay: 1e3
  });
  return {
    data: n ?? null,
    error: l,
    isLoading: s,
    isFetching: d
  };
}
function Kt(e) {
  return !!(e != null && e.nextPage);
}
function Qt(e, t) {
  if (e && typeof e == "object") {
    const n = e, l = n.id ?? n.entity_id;
    if (typeof l == "string" || typeof l == "number")
      return String(l);
  }
  return `idx:${t}`;
}
function Yt(e, t) {
  var b, O;
  const [n, l] = q(
    () => (t == null ? void 0 : t.initialFilters) ?? {}
  ), [s] = q(() => (t == null ? void 0 : t.initialLimit) ?? 100), [d, i] = q(
    () => {
      var T;
      return (t == null ? void 0 : t.initialSort) ?? ((T = t == null ? void 0 : t.params) == null ? void 0 : T.sort);
    }
  ), o = t == null ? void 0 : t.params, r = (t == null ? void 0 : t.getHasNextPage) ?? Kt, p = v(
    () => ({
      ...o ?? {},
      limit: s,
      filters: n,
      ...d !== void 0 ? { sort: d } : {}
    }),
    [n, s, d, o]
  ), N = v(
    () => ({
      ...p,
      page: 1
    }),
    [p]
  ), m = v(
    () => Nt.entityList(e, {
      ...p,
      infinite: !0
    }),
    [e, p]
  ), g = v(() => ({}), []), f = Rt({
    queryKey: m,
    enabled: (t == null ? void 0 : t.enabled) ?? !0,
    initialPageParam: 1,
    retry: t == null ? void 0 : t.retry,
    retryDelay: t == null ? void 0 : t.retryDelay,
    queryFn: ({ pageParam: T }) => Ot(
      e,
      { ...p, page: T },
      g
    ),
    getNextPageParam: (T, x, $) => {
      if (r(T))
        return $ + 1;
    }
  }), C = v(() => {
    var Y;
    const T = ((Y = f.data) == null ? void 0 : Y.pages) ?? [], x = [], $ = /* @__PURE__ */ new Set();
    let L = 0;
    for (const Q of T)
      for (const M of Q.data ?? []) {
        const U = Qt(M, L);
        L += 1, !$.has(U) && ($.add(U), x.push(M));
      }
    return x;
  }, [(b = f.data) == null ? void 0 : b.pages]), A = v(() => {
    var T, x;
    if ((x = (T = f.data) == null ? void 0 : T.pages) != null && x.length)
      return {
        data: C,
        page: f.data.pages.length,
        limit: s,
        nextPage: f.hasNextPage
      };
  }, [
    C,
    (O = f.data) == null ? void 0 : O.pages,
    f.hasNextPage,
    s
  ]), w = jt(), R = F(
    () => w.invalidateQueries({ queryKey: m }),
    [w, m]
  ), K = F(async () => {
    await f.refetch();
  }, [f]), _ = F(
    async (T) => {
      if (typeof T > "u") {
        await w.invalidateQueries({ queryKey: m });
        return;
      }
      const x = await Promise.resolve(T);
      return w.setQueryData(m, {
        pages: [x],
        pageParams: [1]
      }), x;
    },
    [w, m]
  ), S = F(
    async () => f.refetch(),
    [f]
  ), j = F((T) => {
    l(T);
  }, []), E = F((T) => {
    const x = Array.isArray(T) ? T : [T];
    i(x.length > 0 ? T : void 0);
  }, []), I = F(async () => {
    !f.hasNextPage || f.isFetchingNextPage || await f.fetchNextPage();
  }, [f]), h = v(
    () => ({
      mutate: _,
      invalidate: R,
      refresh: K,
      refetch: S,
      setFilters: j,
      setSort: E,
      fetchNextPage: I
    }),
    [
      _,
      R,
      K,
      S,
      j,
      E,
      I
    ]
  );
  return [v(
    () => ({
      data: A,
      isLoading: f.isLoading,
      isFetching: f.isFetching,
      isFetchingNextPage: f.isFetchingNextPage,
      error: f.error ?? null,
      hasNextPage: f.hasNextPage ?? !1
    }),
    [
      A,
      f.isLoading,
      f.isFetching,
      f.isFetchingNextPage,
      f.error,
      f.hasNextPage
    ]
  ), h, N];
}
const De = (e, t) => `${e.charAt(0).toUpperCase() + e.slice(1)} #${t}`, jn = (e) => {
  if (!e)
    return "";
  let t = e.replace(/_/g, " ");
  return t = t.replace(/\b\w/g, (n) => n.toUpperCase()), t;
}, Mt = [];
function Kn({
  entity: e,
  title: t,
  openEditOnRowClick: n = !0,
  getRowContextMenuItems: l,
  addButtonLabel: s = "Add",
  onAfterMutation: d,
  panel: i,
  onPanelChange: o,
  persistedListSearch: r,
  onPersistedListSearchChange: p
}) {
  var Ne, Oe;
  const m = (Ne = ye().data) == null ? void 0 : Ne[e], g = v(() => `table-view:${e}`, [e]), f = te(
    (c) => {
      var P;
      return ((P = c.tablePreferencesByKey[g]) == null ? void 0 : P.sorting) ?? Me;
    }
  ), C = te(
    (c) => c.setSorting
  ), A = te(
    (c) => {
      var P;
      return ((P = c.tablePreferencesByKey[g]) == null ? void 0 : P.columns.order) ?? Mt;
    }
  ), w = te(
    (c) => {
      var P;
      return (P = c.tablePreferencesByKey[g]) == null ? void 0 : P.columns.visibility;
    }
  ), R = te(
    (c) => {
      var P;
      return ((P = c.tablePreferencesByKey[g]) == null ? void 0 : P.columns.customized) === !0;
    }
  ), K = te(
    (c) => c.saveColumnLayout
  ), _ = v(() => {
    var P, W;
    return (((W = (P = m == null ? void 0 : m.ui) == null ? void 0 : P.table) == null ? void 0 : W.columns) ?? []).filter(
      (ee) => ee in ((m == null ? void 0 : m.columns) ?? {})
    );
  }, [m]), [S, j] = q([]), E = ce(!1), I = ce(!1), h = v(() => {
    if (f.length > 0)
      return he(f);
    const c = He(m);
    return c.length > 0 ? c : void 0;
  }, [m, f]), u = v(
    () => Tt(m),
    [m]
  );
  z(() => {
    E.current = !1, I.current = !1, j([]);
  }, [g, e]), z(() => {
    if (_.length === 0) {
      j([]);
      return;
    }
    if (!R) {
      j([..._]), E.current = !0;
      return;
    }
    const c = w ?? {}, P = new Set(_), ee = [
      ...A.filter(
        (ie) => P.has(ie)
      ),
      ..._.filter(
        (ie) => !A.includes(ie)
      )
    ].filter(
      (ie) => c[ie]
    );
    j(
      ee.length > 0 ? ee : [..._]
    ), E.current = !0;
  }, [
    _,
    A,
    w,
    R,
    g
  ]);
  const b = v(() => _.length === 0 ? [] : S.length === 0 ? [..._] : S.filter(
    (c) => _.includes(c)
  ), [_, S]), O = F(
    (c) => {
      I.current = !0;
      const P = c.filter(
        (W) => _.includes(W)
      );
      j(P);
    },
    [_]
  );
  z(() => {
    if (!I.current || _.length === 0 || !E.current || b.length === 0)
      return;
    const c = _.reduce(
      (W, ee) => ({
        ...W,
        [ee]: b.includes(ee)
      }),
      {}
    ), P = _.filter(
      (W) => !b.includes(W)
    );
    K(g, {
      order: [...b, ...P],
      visibility: c
    });
  }, [
    _,
    b,
    K,
    g
  ]);
  const [T, x] = q({ mode: "list" }), $ = i ?? T, L = o ?? x, [Y, Q, M, U] = _t(
    e,
    {
      initialFilters: r !== void 0 ? { search: r } : {},
      initialLimit: 100,
      initialSort: h,
      queryOptions: { retry: 2, retryDelay: 800 }
    }
  ), le = v(() => {
    const c = U.sort;
    if (!c)
      return f;
    const P = Array.isArray(c) ? c : [c];
    return qe(P);
  }, [U.sort, f]), de = F(
    (c) => {
      C(g, c), M.setSort(he(c));
    },
    [M, C, g]
  ), be = v(
    () => ({
      ...Y,
      pagination: Q
    }),
    [
      Y.data,
      Y.isLoading,
      Y.isFetching,
      Y.error,
      Q.page,
      Q.limit,
      Q.hasNextPage,
      Q.canGoPrev
    ]
  ), ae = v(() => {
    const c = U.filters;
    return c && typeof c == "object" && !Array.isArray(c) ? { ...c } : {};
  }, [U.filters]), pe = r !== void 0 ? r : String(ae.search ?? ""), ve = F(
    (c) => {
      p == null || p(c), M.setFilters({
        ...ae,
        search: c
      });
    },
    [M, ae, p]
  ), { inputValue: _e, onChange: ue } = Ue(pe, ve), se = F(async () => {
    await (d == null ? void 0 : d()), await M.invalidate();
  }, [M, d]), oe = F(
    async (c) => {
      let P = c;
      return $.mode === "create" ? P = await kt(e, c) : $.mode === "edit" && (P = await Et(e, c, $.id)), await se(), L({ mode: "list" }), P;
    },
    [e, $, se]
  ), X = $.mode === "edit" || $.mode === "view" ? $.id : null, [{ data: y, isLoading: k }] = Ve(
    e,
    X,
    {
      enabled: ($.mode === "edit" || $.mode === "view") && X != null
    }
  ), J = v(
    () => Le(e),
    [e]
  ), G = Lt(e), Z = t ?? ((Oe = m == null ? void 0 : m.ui) == null ? void 0 : Oe.label) ?? e, Fe = F(
    (c) => {
      !n || (c == null ? void 0 : c.id) == null || L({
        mode: G ? "edit" : "view",
        id: Number(c.id)
      });
    },
    [n, G]
  );
  return /* @__PURE__ */ B(D, { vertical: !0, gap: 16, children: [
    $.mode === "list" && /* @__PURE__ */ B(Re, { children: [
      /* @__PURE__ */ B(D, { align: "center", gap: 12, wrap: "wrap", children: [
        /* @__PURE__ */ a(
          Qe,
          {
            allowClear: !0,
            placeholder: "Search…",
            style: { maxWidth: 320 },
            value: _e,
            onChange: ue
          }
        ),
        /* @__PURE__ */ B(
          D,
          {
            gap: 8,
            style: { marginLeft: "auto" },
            wrap: "wrap",
            children: [
              J && /* @__PURE__ */ a(
                re,
                {
                  type: "primary",
                  onClick: () => {
                    L({ mode: "create" });
                  },
                  children: s
                }
              ),
              /* @__PURE__ */ a(
                re,
                {
                  icon: /* @__PURE__ */ a(je, {}),
                  onClick: () => {
                    M.refresh();
                  },
                  loading: Y.isFetching,
                  children: "Refresh"
                }
              )
            ]
          }
        )
      ] }),
      !m && /* @__PURE__ */ B(ne.Text, { type: "warning", children: [
        "Unknown entity: ",
        e
      ] }),
      m && /* @__PURE__ */ a(
        wt,
        {
          entity: e,
          gridData: be,
          pagination: Q,
          onRowClick: Fe,
          getRowContextMenuItems: l,
          visibleColumnKeys: b,
          tablePreferencesKey: g,
          sortableColumnKeys: u,
          sorting: le,
          onSortingChange: de,
          columnOrder: b,
          onColumnOrderChange: O
        }
      )
    ] }),
    $.mode === "create" && /* @__PURE__ */ B(D, { vertical: !0, gap: 16, children: [
      /* @__PURE__ */ a(
        re,
        {
          icon: /* @__PURE__ */ a(ke, {}),
          onClick: () => {
            L({ mode: "list" });
          },
          children: "Back to list"
        }
      ),
      /* @__PURE__ */ B(ne.Title, { level: 5, style: { margin: 0 }, children: [
        "New ",
        Z
      ] }),
      /* @__PURE__ */ a(
        Ae,
        {
          entity: e,
          formMode: "create",
          onSubmit: oe
        },
        `inline-create-${e}`
      )
    ] }),
    ($.mode === "edit" || $.mode === "view") && /* @__PURE__ */ B(D, { vertical: !0, gap: 16, children: [
      /* @__PURE__ */ a(
        re,
        {
          icon: /* @__PURE__ */ a(ke, {}),
          onClick: () => {
            L({ mode: "list" });
          },
          children: "Back to list"
        }
      ),
      /* @__PURE__ */ B(ne.Title, { level: 5, style: { margin: 0 }, children: [
        $.mode === "view" ? "View" : "Edit",
        " ",
        Z
      ] }),
      k && /* @__PURE__ */ a(ge, { tip: "Loading…" }),
      !k && y && /* @__PURE__ */ a(
        Ae,
        {
          entity: e,
          formMode: $.mode === "view" ? "read" : "edit",
          formID: X,
          initialValues: y,
          pattern: $.mode === "view" ? "readPretty" : "editable",
          showActions: $.mode === "edit",
          onSubmit: $.mode === "edit" ? oe : void 0
        },
        `inline-${$.mode}-${e}-${X}`
      )
    ] })
  ] });
}
const Vt = "_filterCard_1d0d3_1", Ut = "_searchBar_1d0d3_13", Wt = "_refreshBtn_1d0d3_54", Te = {
  filterCard: Vt,
  searchBar: Ut,
  refreshBtn: Wt
}, Ht = ({
  initialFilters: e,
  onFilterChange: t
}) => {
  const [n, l] = q(e || {}), s = ce(!0);
  z(() => {
    if (s.current) {
      s.current = !1;
      return;
    }
    t(n);
  }, [n]);
  const d = F((i, o) => {
    l((r) => ({ ...r, [i]: o }));
  }, []);
  return {
    filters: n,
    handleFilterChange: d
  };
}, Qn = ({
  initialFilters: e,
  entityDef: t,
  entityColOverride: n,
  onFilterChange: l,
  refresh: s,
  loading: d,
  onAddNew: i
}) => {
  const { filters: o, handleFilterChange: r } = Ht({
    initialFilters: e,
    onFilterChange: l
  }), p = F(
    (g) => {
      r("search", g);
    },
    [r]
  ), { inputValue: N, onChange: m } = Ue(
    String(o.search ?? ""),
    p
  );
  return /* @__PURE__ */ a(bt, { className: Te.filterCard, bordered: !1, children: /* @__PURE__ */ B(D, { align: "center", justify: "space-between", gap: 16, children: [
    /* @__PURE__ */ a(
      Qe,
      {
        prefix: /* @__PURE__ */ a(Ze, {}),
        placeholder: "Search...",
        allowClear: !0,
        size: "middle",
        className: Te.searchBar,
        value: N,
        onChange: m,
        style: { flex: 1 }
      }
    ),
    /* @__PURE__ */ B(D, { gap: 8, align: "center", children: [
      i && /* @__PURE__ */ a(
        re,
        {
          type: "primary",
          className: "actionCardButton",
          onClick: i,
          children: "Add New"
        }
      ),
      /* @__PURE__ */ a(
        re,
        {
          type: "text",
          className: Te.refreshBtn,
          icon: /* @__PURE__ */ a(je, { style: { fontSize: 18 } }),
          onClick: s,
          loading: d
        }
      )
    ] })
  ] }) });
}, qt = "_flexTabs_14sqk_1", zt = {
  flexTabs: qt
}, Ce = "__new__", Yn = ({
  orientation: e = "horizontal",
  tabs: t = [],
  listConfig: n,
  defaultActiveKey: l
}) => {
  var h;
  const s = ye(), d = n ? At(s.data[n.entity]) : "edit", i = It(d), o = ce(0), r = l || (n ? "list" : (h = t[0]) == null ? void 0 : h.key), [p, N] = q(r), [m, g] = q([]), f = (n == null ? void 0 : n.getTabLabel) || ((u) => `ID ${u.id}`), C = n == null ? void 0 : n.RowComponent, A = (n == null ? void 0 : n.showNewButton) ?? !0, w = (n == null ? void 0 : n.listLabel) ?? "List", R = (n == null ? void 0 : n.newButtonLabel) ?? "+ New", K = F(
    (u) => {
      g((b) => b.filter((O) => O.key !== u)), N(
        (b) => {
          var O;
          return b === u ? n ? "list" : ((O = t[0]) == null ? void 0 : O.key) ?? "list" : b;
        }
      );
    },
    [n, t]
  ), _ = F(
    (u) => {
      if (!n) return;
      const b = `row-${u.id}`;
      g((O) => {
        if (O.some((x) => x.key === b))
          return O;
        const T = C ? /* @__PURE__ */ a(
          C,
          {
            data: u,
            ...n.rowComponentProps
          }
        ) : /* @__PURE__ */ a(
          Ie,
          {
            entity: n.entity,
            data: u,
            mode: i,
            onArchived: () => {
              K(b);
            }
          }
        );
        return [
          ...O,
          {
            key: b,
            label: f(u),
            children: T,
            closable: !0
          }
        ];
      }), N(b);
    },
    [
      n,
      C,
      f,
      K,
      i
    ]
  ), S = F(() => {
    if (!n) return;
    o.current += 1;
    const u = `create-${o.current}`;
    g((b) => [
      ...b,
      {
        key: u,
        label: `New ${n.entity}`,
        children: /* @__PURE__ */ a(Ie, { entity: n.entity, mode: "create" }),
        closable: !0
      }
    ]), N(u);
  }, [n]), j = F(
    (u, b) => {
      var O;
      b === "remove" && typeof u == "string" && (g(
        (T) => T.filter((x) => x.key !== u)
      ), p === u && N(n ? "list" : (O = t[0]) == null ? void 0 : O.key));
    },
    [p, n, t]
  ), E = F(
    (u) => {
      if (u === Ce) {
        S();
        return;
      }
      N(u);
    },
    [S]
  ), I = v(() => {
    const u = [];
    return n && u.push({
      key: "list",
      label: w,
      children: /* @__PURE__ */ a(
        We,
        {
          entity: n.entity,
          entityColOverride: n.entityColOverride,
          customColumnDefs: n.customColumnDefs,
          customColumnDefsPosition: n.customColumnDefsPosition,
          onRowClick: _
        }
      ),
      closable: !1
    }), u.push(
      ...t.map((b) => ({
        key: b.key,
        label: b.label,
        children: b.children,
        closable: !1
      }))
    ), u.push(...m), n && A && u.push({
      key: Ce,
      label: R,
      children: null,
      closable: !1
    }), u;
  }, [
    n,
    t,
    m,
    w,
    _,
    A,
    R
  ]);
  return /* @__PURE__ */ a(
    Ye,
    {
      className: zt.flexTabs,
      type: "editable-card",
      hideAdd: !0,
      tabPosition: e === "vertical" ? "left" : "top",
      activeKey: p,
      onChange: E,
      onEdit: j,
      items: I
    }
  );
}, Gt = "_root_p8sef_1", Xt = "_content_p8sef_6", Jt = "_tableSection_p8sef_11", Zt = "_loadMoreStatus_p8sef_17", me = {
  root: Gt,
  content: Xt,
  tableSection: Jt,
  loadMoreStatus: Zt
}, { Text: en } = ne, tn = 80;
function nn(e) {
  if (!e)
    return null;
  const t = e.querySelectorAll("*");
  for (const n of t) {
    const s = window.getComputedStyle(n).overflowY;
    if ((s === "auto" || s === "scroll") && n.scrollHeight > n.clientHeight)
      return n;
  }
  for (const n of t) {
    const s = window.getComputedStyle(n).overflowY;
    if (s === "auto" || s === "scroll")
      return n;
  }
  return null;
}
const rn = ({
  entity: e,
  entityColOverride: t,
  customColumnDefs: n,
  customColumnDefsPosition: l,
  presetFilters: s,
  scope: d,
  onRowClick: i,
  getRowContextMenuItems: o,
  showAddButton: r = !0,
  showEditButton: p = !0,
  entityDefOverride: N,
  initialSortOverride: m,
  buildBaseListUrl: g,
  rowSelectionMode: f,
  tableActions: C,
  initialLimit: A = 100
}) => {
  var ue, se, oe, X;
  const w = Pe(), R = xt((y) => y.access), K = ye(), _ = N ?? K.data[e], S = Pt(), j = ce(null), E = v(() => {
    if (d && (S != null && S.parentID)) {
      const y = String(S.parentID);
      if (y)
        return `${S.parent}-${y}-${d.split("-").pop()}`;
    }
    return d;
  }, [d, S == null ? void 0 : S.parent, S == null ? void 0 : S.parentID]), I = v(() => {
    const y = (s == null ? void 0 : s.filters) || {}, k = {};
    for (const [G, Z] of Object.entries((S == null ? void 0 : S.links) || {}))
      k[`${G}_id`] = Z;
    const J = { ...y, ...k };
    return Object.keys(J).length === 0 ? s : { filters: J };
  }, [s == null ? void 0 : s.filters, S == null ? void 0 : S.links]), h = Be((y) => y.getFilters), u = Be((y) => y.setFilters), b = v(
    () => `table-view:${e}`,
    [e]
  ), O = te(
    (y) => {
      var k;
      return ((k = y.tablePreferencesByKey[b]) == null ? void 0 : k.sorting) ?? Me;
    }
  ), T = v(() => {
    if (O.length > 0)
      return he(O);
    if (m !== void 0)
      return m;
    const y = He(_);
    return y.length > 0 ? y : void 0;
  }, [_, m, O]), x = v(
    () => g ? { buildBaseListUrl: g } : void 0,
    [g]
  ), $ = v(() => {
    const y = E ? h(E) : {};
    return Object.keys(y).length > 0 ? y : (I == null ? void 0 : I.filters) || {};
  }, [E, h, I == null ? void 0 : I.filters]), [L, Y, Q] = Yt(e, {
    initialFilters: $,
    initialLimit: A,
    initialSort: T,
    params: x,
    retry: 3,
    retryDelay: 1e3
  }), M = v(() => {
    const y = Q.sort;
    if (!y)
      return O;
    const k = Array.isArray(y) ? y : [y];
    return qe(k);
  }, [Q.sort, O]), { setFilters: U, setSort: le, fetchNextPage: de } = Y, be = F(
    (y) => {
      U(y), E && u(E, y);
    },
    [U, E, u]
  ), ae = F(
    (y) => {
      le(he(y));
    },
    [le]
  ), pe = v(
    () => ({
      data: L.data,
      isLoading: L.isLoading,
      isFetching: L.isFetching,
      error: L.error,
      listParams: Q
    }),
    [
      L.data,
      L.isLoading,
      L.isFetching,
      L.error,
      Q
    ]
  ), ve = v(() => {
    if (!(!r || !Le(e)))
      return () => void w({
        to: ".",
        search: {
          mode: "create"
        }
      });
  }, [r, e, R, w]);
  z(() => {
    const y = j.current;
    if (!y)
      return;
    let k = null, J = 0;
    const G = () => {
      if (!k || !L.hasNextPage || L.isFetchingNextPage)
        return;
      k.scrollHeight - k.scrollTop - k.clientHeight < tn && de();
    }, Z = () => {
      if (k = nn(y), !k) {
        J = window.requestAnimationFrame(Z);
        return;
      }
      k.addEventListener("scroll", G, { passive: !0 }), G();
    };
    return Z(), () => {
      window.cancelAnimationFrame(J), k == null || k.removeEventListener("scroll", G);
    };
  }, [
    de,
    L.hasNextPage,
    L.isFetchingNextPage,
    (se = (ue = L.data) == null ? void 0 : ue.data) == null ? void 0 : se.length
  ]);
  const _e = L.isLoading || L.isFetching && !((X = (oe = L.data) == null ? void 0 : oe.data) != null && X.length);
  return /* @__PURE__ */ B(D, { vertical: !0, className: me.root, children: [
    !_ && /* @__PURE__ */ a($e, { type: "warning", message: "Entity not found", showIcon: !0 }),
    _ && /* @__PURE__ */ B(D, { vertical: !0, gap: 12, className: me.content, children: [
      /* @__PURE__ */ a("div", { ref: j, className: me.tableSection, children: /* @__PURE__ */ a(
        St,
        {
          entity: e,
          scope: E ?? e,
          entityColOverride: t,
          customColumnDefs: n,
          customColumnDefsPosition: l,
          tableData: pe,
          onRowClick: i,
          getRowContextMenuItems: o,
          entityDefOverride: N,
          filters: Q.filters,
          onFilterChange: be,
          onSortChange: ae,
          sorting: M,
          refresh: () => {
            Y.refresh();
          },
          loading: _e,
          onAddNew: ve,
          showEditButton: p,
          rowSelectionMode: f,
          tableActions: C
        },
        e
      ) }),
      L.isFetchingNextPage && /* @__PURE__ */ B(
        D,
        {
          justify: "center",
          align: "center",
          gap: 8,
          className: me.loadMoreStatus,
          children: [
            /* @__PURE__ */ a(ge, { size: "small" }),
            /* @__PURE__ */ a(en, { type: "secondary", children: "Loading more…" })
          ]
        }
      )
    ] })
  ] });
}, an = "_loadingWrap_6nwtk_1", sn = {
  loadingWrap: an
}, on = {
  string: "varchar",
  number: "int",
  date: "timestamp",
  boolean: "boolean",
  json: "json"
};
function cn(e, t) {
  const n = [], l = [], s = [], d = {};
  for (const r of e)
    r.hidden || (n.push(r.field), r.filterable !== !1 && l.push(r.field), r.sortable !== !1 && s.push(r.field), d[r.field] = {
      type: on[r.type] ?? "varchar",
      ui: { label: r.title }
    });
  const o = (t != null && t.field ? [
    t.field,
    ...s.filter((r) => r !== t.field)
  ] : s).map((r) => (t == null ? void 0 : t.field) === r && t.direction === "DESC" ? `-${r}` : r);
  return {
    name: "__query__",
    columns: d,
    ui: {
      table: {
        columns: n,
        filters: l,
        sort: o
      }
    }
  };
}
function ln(e) {
  if (!e) return "";
  const t = [];
  for (const [n, l] of Object.entries(e))
    l == null || l === "" || t.push(
      `p_${encodeURIComponent(n)}=${encodeURIComponent(String(l))}`
    );
  return t.join("&");
}
const Mn = ({
  queryCode: e,
  parameters: t,
  presetFilters: n,
  scope: l,
  onRowClick: s,
  initialLimit: d = 100
}) => {
  var N, m;
  const i = Je(e), o = v(
    () => i.data ? cn(
      i.data.columns,
      i.data.defaultSort
    ) : null,
    [i.data]
  ), r = F(
    (g, f) => {
      const C = ln(t), w = [ze(f), C].filter(Boolean).join("&");
      return w ? `/query/${e}/list?${w}` : `/query/${e}/list`;
    },
    [e, t]
  ), p = v(
    () => {
      var g;
      return Ge((g = i.data) == null ? void 0 : g.defaultSort);
    },
    [(N = i.data) == null ? void 0 : N.defaultSort]
  );
  return /* @__PURE__ */ B(Re, { children: [
    i.isLoading && /* @__PURE__ */ a(
      D,
      {
        justify: "center",
        align: "center",
        className: sn.loadingWrap,
        children: /* @__PURE__ */ a(ge, { size: "large" })
      }
    ),
    !i.isLoading && (i.error || !o) && /* @__PURE__ */ a(
      $e,
      {
        type: "error",
        message: `Failed to load query metadata for "${e}"`,
        description: (m = i.error) == null ? void 0 : m.message,
        showIcon: !0
      }
    ),
    !i.isLoading && !i.error && o && /* @__PURE__ */ a(
      rn,
      {
        entity: `query/${e}`,
        entityDefOverride: o,
        buildBaseListUrl: r,
        initialSortOverride: p,
        presetFilters: n,
        scope: l,
        onRowClick: s,
        showAddButton: !1,
        initialLimit: d
      }
    )
  ] });
}, dn = ({
  parent: e,
  parentID: t,
  children: n
}) => {
  const [l, s] = q({ [e]: t }), d = (i, o) => {
    s((r) => ({ ...r, [i]: o }));
  };
  return z(() => {
    s({ [e]: t });
  }, [e, t]), /* @__PURE__ */ a(
    Ft.Provider,
    {
      value: { parent: e, parentID: t, links: l, addLink: d },
      children: n
    }
  );
}, un = "_loadingWrap_6nwtk_1", mn = {
  loadingWrap: un
}, fn = {
  string: "varchar",
  number: "int",
  date: "timestamp",
  boolean: "boolean",
  json: "json"
};
function hn(e, t) {
  const n = [], l = [], s = [], d = {};
  for (const r of e)
    r.hidden || (n.push(r.field), r.filterable !== !1 && l.push(r.field), r.sortable !== !1 && s.push(r.field), d[r.field] = {
      type: fn[r.type] ?? "varchar",
      ui: { label: r.title }
    });
  const o = (t != null && t.field ? [
    t.field,
    ...s.filter((r) => r !== t.field)
  ] : s).map((r) => (t == null ? void 0 : t.field) === r && t.direction === "DESC" ? `-${r}` : r);
  return {
    name: "__query__",
    columns: d,
    ui: {
      table: {
        columns: n,
        filters: l,
        sort: o
      }
    }
  };
}
function gn(e) {
  if (!e) return "";
  const t = [];
  for (const [n, l] of Object.entries(e))
    l == null || l === "" || t.push(
      `p_${encodeURIComponent(n)}=${encodeURIComponent(String(l))}`
    );
  return t.join("&");
}
const Vn = ({
  queryCode: e,
  parameters: t,
  presetFilters: n,
  scope: l,
  onRowClick: s
}) => {
  var p, N;
  const d = Je(e), i = v(
    () => d.data ? hn(
      d.data.columns,
      d.data.defaultSort
    ) : null,
    [d.data]
  ), o = F(
    (m, g) => {
      const f = gn(t), A = [ze(g), f].filter(Boolean).join("&");
      return A ? `/query/${e}/list?${A}` : `/query/${e}/list`;
    },
    [e, t]
  ), r = v(
    () => {
      var m;
      return Ge((m = d.data) == null ? void 0 : m.defaultSort);
    },
    [(p = d.data) == null ? void 0 : p.defaultSort]
  );
  return d.isLoading ? /* @__PURE__ */ a(
    D,
    {
      justify: "center",
      align: "center",
      className: mn.loadingWrap,
      children: /* @__PURE__ */ a(ge, { size: "large" })
    }
  ) : d.error || !i ? /* @__PURE__ */ a(
    $e,
    {
      type: "error",
      message: `Failed to load query metadata for "${e}"`,
      description: (N = d.error) == null ? void 0 : N.message,
      showIcon: !0
    }
  ) : /* @__PURE__ */ a(
    We,
    {
      entity: `query/${e}`,
      entityDefOverride: i,
      buildBaseListUrl: o,
      initialSortOverride: r,
      presetFilters: n,
      scope: l,
      onRowClick: s,
      showAddButton: !1
    }
  );
}, yn = "_container_1cbpj_30", bn = "_mainContent_1cbpj_37", pn = "_leftNav_1cbpj_44", vn = "_content_1cbpj_141", fe = {
  container: yn,
  mainContent: bn,
  leftNav: pn,
  content: vn
}, _n = {
  // Patient
  snapshot: /* @__PURE__ */ a(gt, {}),
  communication: /* @__PURE__ */ a(ht, {}),
  call: /* @__PURE__ */ a(ft, {}),
  "welcome-call": /* @__PURE__ */ a(mt, {}),
  coverage: /* @__PURE__ */ a(Ee, {}),
  case: /* @__PURE__ */ a(Ke, {}),
  dispense: /* @__PURE__ */ a(ut, {}),
  "claim-lines": /* @__PURE__ */ a(dt, {}),
  pap: /* @__PURE__ */ a(xe, {}),
  "copay-program": /* @__PURE__ */ a(lt, {}),
  "discount-drug-program": /* @__PURE__ */ a(ct, {}),
  attachment: /* @__PURE__ */ a(it, {}),
  schedule: /* @__PURE__ */ a(ot, {}),
  faxes: /* @__PURE__ */ a(st, {}),
  // Plan
  "claim-dispense": /* @__PURE__ */ a(at, {}),
  invoices: /* @__PURE__ */ a(rt, {}),
  group: /* @__PURE__ */ a(nt, {}),
  formulary: /* @__PURE__ */ a(tt, {}),
  "group-formulary": /* @__PURE__ */ a(et, {}),
  // Alert
  medications: /* @__PURE__ */ a(xe, {}),
  allergies: /* @__PURE__ */ a(Ee, {})
};
function Sn(e) {
  return _n[e] ?? /* @__PURE__ */ a(Ke, {});
}
const Un = ({
  parentScope: e,
  basePath: t,
  subEntities: n
}) => {
  const l = Pe(), { pathname: s } = Bt(), d = H(
    (r) => r.setActiveSubTab
  ), i = H(
    (r) => r.getActiveSubTab
  ), o = n.find(
    (r) => s.includes(`${t}/${r.path}`)
  );
  return z(() => {
    if (s.startsWith(t))
      if (o)
        d(e, o.path);
      else {
        const r = i(e);
        l({
          to: `${t}/${r ?? n[0].path}`
        });
      }
  }, [s, t, o, e, d]), /* @__PURE__ */ a(D, { vertical: !0, className: fe.container, children: /* @__PURE__ */ B(D, { flex: 1, className: fe.mainContent, children: [
    /* @__PURE__ */ a("div", { className: fe.leftNav, children: /* @__PURE__ */ a(
      pt,
      {
        mode: "vertical",
        selectedKeys: o ? [o.path] : [],
        items: n.map((r) => ({
          key: r.path,
          icon: r.icon ?? Sn(r.path),
          label: /* @__PURE__ */ a(
            Dt,
            {
              to: `${t}/${r.path}`,
              children: r.label
            }
          )
        }))
      }
    ) }),
    /* @__PURE__ */ a(D, { flex: 1, vertical: !0, className: fe.content, children: /* @__PURE__ */ a(Xe, {}) })
  ] }) });
}, Tn = "_container_yrkwm_1", wn = "_content_yrkwm_5", $n = "_closeIcon_yrkwm_15", we = {
  container: Tn,
  content: wn,
  closeIcon: $n
}, Ln = [], V = "create", Wn = ({
  entity: e,
  basePath: t,
  paramName: n,
  scope: l
}) => {
  var I;
  const s = Pe(), i = Ct({ strict: !1 })[n], o = l ?? e, r = Le(e), p = i === V, N = H(
    (h) => h.tabsByScope[o] ?? Ln
  ), m = H((h) => h.isTabOpen), g = H((h) => h.addOpenTab), f = H((h) => h.setTabLabel), C = H((h) => h.removeOpenTab), A = H((h) => h.getActiveTab), w = H((h) => h.setActiveTab), R = ye().data[e], [{ data: K }] = Ve(
    e,
    i && !p ? i : null
  ), _ = i ? `${o}-${i}` : "list", S = F(
    async (h) => {
      if (h === "__add__") {
        if (!r)
          return;
        g(o, V, `New ${e}`), w(o, V), await s({ to: `${t}/${V}` });
        return;
      }
      if (h === `${o}-${V}`)
        w(o, V), await s({ to: `${t}/${V}` });
      else if (h === "list")
        w(o, null), await s({ to: t });
      else {
        const u = h.replace(`${o}-`, "");
        w(o, u), await s({ to: `${t}/${u}` });
      }
    },
    [o, w, g, s, t, e, r]
  );
  z(() => {
    if (i && p)
      m(o, V) || g(o, V, `New ${e}`), w(o, V);
    else if (i)
      m(o, i) || g(
        o,
        i,
        De(e, i)
      ), w(o, i);
    else if (!i) {
      const h = A(o);
      h && s({ to: `${t}/${h}` });
    }
  }, [
    i,
    o,
    m,
    g,
    e,
    w,
    A,
    s,
    t,
    p
  ]), z(() => {
    var b;
    if (!i || p || !K) return;
    const u = $t(
      ((b = R == null ? void 0 : R.ui) == null ? void 0 : b.nameTemplate) ?? "{name}",
      K
    ).trim() || De(e, i);
    f(o, i, u);
  }, [
    i,
    p,
    K,
    (I = R == null ? void 0 : R.ui) == null ? void 0 : I.nameTemplate,
    e,
    o,
    f
  ]);
  const j = F(
    (h, u) => {
      h.stopPropagation(), u === V ? Se(e, "create", "new") : (Se(e, "edit", u), Se(e, "create", u)), C(o, u), (i === u || u === V && p) && (w(o, null), s({ to: t }));
    },
    [
      C,
      o,
      i,
      p,
      w,
      s,
      t,
      e
    ]
  ), E = v(
    () => [
      {
        key: "list",
        label: /* @__PURE__ */ a(ne.Text, { children: "List" }),
        closable: !1
      },
      ...N.map((h) => ({
        key: `${o}-${h.id}`,
        label: /* @__PURE__ */ B(D, { align: "center", gap: 8, children: [
          /* @__PURE__ */ a(ne.Text, { children: h.label }),
          /* @__PURE__ */ a(
            yt,
            {
              onClick: (u) => {
                j(u, h.id);
              },
              className: we.closeIcon
            }
          )
        ] }),
        closable: !1
      })),
      ...r ? [
        {
          key: "__add__",
          label: /* @__PURE__ */ a(ne.Text, { children: "+ Add" }),
          closable: !1
        }
      ] : []
    ],
    [N, o, j, r]
  );
  return /* @__PURE__ */ B(D, { vertical: !0, className: we.container, children: [
    /* @__PURE__ */ a(
      Ye,
      {
        activeKey: _,
        items: E,
        onTabClick: S
      }
    ),
    /* @__PURE__ */ a(D, { vertical: !0, flex: 1, className: we.content, children: /* @__PURE__ */ a(dn, { parent: e, parentID: i ?? "", children: /* @__PURE__ */ a(Xe, {}) }) })
  ] });
};
export {
  Kn as E,
  Qn as F,
  Mn as I,
  dn as L,
  Vn as Q,
  Un as S,
  Wn as T,
  Yn as a,
  rn as b,
  Yt as c,
  De as g,
  jn as t,
  Je as u
};
